import { NgClass } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-codebox',
  styleUrls: ['./email-codebox.component.less'],
  template: `
    <span
      [ngClass]="{
        codebox: true,
        'codebox-inline': inline,
        'codebox-block': !inline,
        'codebox-tellent': theme === 'tellent',
        'codebox-full-width': fullWidth,
      }"
    >
      <table class="codebox-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="codebox-content">
            <email-text [contents]="code" [className]="'codebox-text'" />
          </td>
        </tr>
      </table>
    </span>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
  imports: [EmailTextComponent, NgClass],
})
export class EmailCodeBoxComponent {
  @Input() public theme: 'default' | 'tellent' = 'default';
  @Input() public code: WrappedValue<string>;
  @Input() public inline: boolean = false;
  @Input() public fullWidth: boolean = false;
}
